import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { ensureProducts } from 'apps/products/actions/products';
import { showMoreMainFopCollectionFops } from '../actions/catalogue';

import withScrollWatcher from 'apps/fops/containers/withScrollWatcher';

import MainFopContainer from '../components/MainFopContainer';

export default withScrollWatcher(ensureProducts)(
  connect(
    (state, ownProps) => ({
      basket: state.basket,
      basketItems: state.basket.items,
      fopViewPreference: ownProps.fopViewPreference || state.user.fopViewPreference,
      productsBySku: state.products.productsBySku,
      productWarnings: state.basket.productWarnings,
    }),
    (dispatch) => ({
      dispatch,
      ...bindActionCreators({ showMoreMainFopCollectionFops }, dispatch),
    })
  )(MainFopContainer)
);
